/*! rb-pci-collection-items-per-row-v2 — whitelist + clear invalid cart attrs; block bad writes */
(function () {
  'use strict';

  var ATTR = 'collection_items_per_row';
  var ALLOWED = /^(?:list_t4s|[1-6])\.(?:list_t4s|[1-6])\.(?:list_t4s|[1-6])$/;

  function isCartUrl(url) {
    if (!url) return false;
    try {
      var u = String(url);
      return /\/cart(\.js|\/add|\.add|\/change|\.change|\/update|\.update|\/clear|\.clear)?(\?|$)/i.test(u);
    } catch (e) {
      return false;
    }
  }

  function sanitizeValue(val) {
    if (val == null) return '';
    var s = String(val).trim();
    return ALLOWED.test(s) ? s : '';
  }

  function sanitizeAttributesObject(attrs) {
    if (!attrs || typeof attrs !== 'object') return attrs;
    if (Object.prototype.hasOwnProperty.call(attrs, ATTR)) {
      attrs[ATTR] = sanitizeValue(attrs[ATTR]);
    }
    return attrs;
  }

  function sanitizeJsonBody(body) {
    if (typeof body !== 'string') return body;
    try {
      var data = JSON.parse(body);
      if (data && data.attributes) {
        sanitizeAttributesObject(data.attributes);
        return JSON.stringify(data);
      }
    } catch (e) {}
    return body;
  }

  function sanitizeFormBody(body) {
    if (typeof body !== 'string') return body;
    var key = 'attributes[' + ATTR + ']';
    if (body.indexOf(key) === -1 && body.indexOf('attributes%5B' + ATTR) === -1) return body;
    try {
      var params = new URLSearchParams(body);
      if (params.has(key)) {
        var clean = sanitizeValue(params.get(key));
        if (clean) params.set(key, clean);
        else params.delete(key);
        return params.toString();
      }
    } catch (e) {}
    return body;
  }

  function clearInvalidAttr() {
    if (!window.__rbClearCollectionItemsPerRow) return;
    var url =
      (window.T4Sroutes && window.T4Sroutes.cart_update_url) || '/cart/update';
    fetch(url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        attributes: { collection_items_per_row: '' },
      }),
    }).catch(function () {});
  }

  /* Intercept fetch cart writes */
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isCartUrl(url) && init && init.body != null) {
          init = Object.assign({}, init);
          if (typeof init.body === 'string') {
            if ((init.headers && String(init.headers['Content-Type'] || init.headers['content-type'] || '').indexOf('json') !== -1) ||
                (init.body.trim().charAt(0) === '{')) {
              init.body = sanitizeJsonBody(init.body);
            } else {
              init.body = sanitizeFormBody(init.body);
            }
          }
        }
      } catch (e) {}
      return nativeFetch.call(this, input, init);
    };
  }

  /* Intercept XHR cart writes */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__rbCartUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isCartUrl(this.__rbCartUrl) && typeof body === 'string') {
          if (body.trim().charAt(0) === '{') body = sanitizeJsonBody(body);
          else body = sanitizeFormBody(body);
        }
      } catch (e) {}
      return nativeSend.call(this, body);
    };
  }

  clearInvalidAttr();
})();
